import React, { useContext } from 'react'
import { VideoTeaserEntry } from '../helper/interfaces';
import { TeaserData } from './teaser'
import { CmpIdentifier } from '../helper/enums';
import { ConsentContext } from '../provider/ConsentContextProvider';
declare global {
  namespace JSX {
    interface IntrinsicElements {
          'glomex-integration': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
      }
  }
}

export default function TeaserVideo(data: TeaserData) {
  const teaser = data.teaser
  let integrationId = process.env.NEXT_PUBLIC_GLOMEX_INTEGRATION_ID

  const videoTeaser = teaser as VideoTeaserEntry;
  const playlistId = videoTeaser.providerId;
  if(videoTeaser.integrationId) {
    integrationId = videoTeaser.integrationId;
  }

  const { getProviderId } = useContext(ConsentContext);
  const cmpVendorId = getProviderId(CmpIdentifier.Glomex);
  
  return (
    <React.Fragment>
      {cmpVendorId &&
        <>
          {/* glomex video */}
          <script className="cmplazyload" data-cmp-vendor={cmpVendorId} type="text/plain" data-cmp-preview="100%x350" data-cmp-ab="1" dangerouslySetInnerHTML={{__html: `
            var glomexScript = document.createElement('script');
            glomexScript.setAttribute('type', 'module');
            glomexScript.src = 'https://player.glomex.com/integration/1/integration.js';
            (document.head || document.body).appendChild(glomexScript);

            var glomexCss = document.createElement('link');
            glomexCss.setAttribute('rel', 'stylesheet');
            glomexCss.setAttribute('href', 'https://player.glomex.com/variant/${integrationId}/variant.css');
            (document.head || document.body).appendChild(glomexCss);
          `}}></script>
          <glomex-integration integration-id={integrationId} playlist-id={playlistId}></glomex-integration>
          {/* /glomex video */}
        </>
      }
    </React.Fragment>
  )
}

